import * as React from 'react';
import ReactTable from 'react-table';
import { defaultTablePageSize } from '~/common/components/consts';
import PaginateSimple from '~/common/components/PaginateSimple';


export default (props) => {
  return (
    <ReactTable
      defaultPageSize={defaultTablePageSize}
      minRows={0}
      showPageSizeOptions={false}
      resizable={false}
      sortable={false}
      PaginationComponent={PaginateSimple}
      {...props}
    />
  );
}
